/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { FilterLabelDTO } from "./FilterLabelDTO";
import { FilterLabelDTOFromJSON, FilterLabelDTOFromJSONTyped, FilterLabelDTOToJSON } from "./FilterLabelDTO";
import type { FilterTypeDTO } from "./FilterTypeDTO";
import { FilterTypeDTOFromJSON, FilterTypeDTOFromJSONTyped, FilterTypeDTOToJSON } from "./FilterTypeDTO";

/**
 *
 * @export
 * @interface PutFilterDTO
 */
export interface PutFilterDTO {
  /**
   *
   * @type {string}
   * @memberof PutFilterDTO
   */
  name: string;
  /**
   *
   * @type {FilterTypeDTO}
   * @memberof PutFilterDTO
   */
  type: FilterTypeDTO;
  /**
   *
   * @type {FilterLabelDTO}
   * @memberof PutFilterDTO
   */
  label?: FilterLabelDTO;
  /**
   *
   * @type {number}
   * @memberof PutFilterDTO
   */
  usageByMerchant?: number;
  /**
   *
   * @type {number}
   * @memberof PutFilterDTO
   */
  usageByDeals?: number;
  /**
   *
   * @type {number}
   * @memberof PutFilterDTO
   */
  id: number;
}

/**
 * Check if a given object implements the PutFilterDTO interface.
 */
export function instanceOfPutFilterDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "id" in value;

  return isInstance;
}

export function PutFilterDTOFromJSON(json: any): PutFilterDTO {
  return PutFilterDTOFromJSONTyped(json, false);
}

export function PutFilterDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutFilterDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    name: json["name"],
    type: FilterTypeDTOFromJSON(json["type"]),
    label: !exists(json, "label") ? undefined : FilterLabelDTOFromJSON(json["label"]),
    usageByMerchant: !exists(json, "usageByMerchant") ? undefined : json["usageByMerchant"],
    usageByDeals: !exists(json, "usageByDeals") ? undefined : json["usageByDeals"],
    id: json["id"]
  };
}

export function PutFilterDTOToJSON(value?: PutFilterDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    name: value.name,
    type: FilterTypeDTOToJSON(value.type),
    label: FilterLabelDTOToJSON(value.label),
    usageByMerchant: value.usageByMerchant,
    usageByDeals: value.usageByDeals,
    id: value.id
  };
}
